import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router";
import { Button, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import AuthService from "../../services/auth.service";
import { setAppLanguage } from "../../store/actions/app.action";
import { getLanguageSelector } from "../../store/selectors/app.selector";
import i18n from "../../i18n";

export const TimeoutWarningModal = ({
  isOpen,
  onRequestClose,
  delayResend = "60",
}) => {
  const [delay, setDelay] = useState(+delayResend);
  const seconds = Math.floor(delay);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedLng = useSelector(getLanguageSelector);

  const logoutCallback = useCallback(async () => {
    try {
      onRequestClose();
      const response = await AuthService.postLogout();
      if (response.status === 200) {
        dispatch({ type: "USER_LOGOUT" });
        dispatch(setAppLanguage(selectedLng));
        i18n.changeLanguage(selectedLng);
      }
    } catch (error) {
      dispatch({ type: "USER_LOGOUT" });
      dispatch(setAppLanguage(selectedLng));
      i18n.changeLanguage(selectedLng);
    }
  }, [dispatch, navigate]);

  useEffect(() => {
    const timer = setInterval(() => {
      setDelay(delay - 1);
    }, 1000);
    if (delay === 1) {
      clearInterval(timer);
      logoutCallback();
    }
    return () => {
      clearInterval(timer);
    };
  }, [delay, logoutCallback]);

  const onLogOffCall = () => {
    dispatch({ type: "USER_LOGOUT" });
    dispatch(setAppLanguage(selectedLng));
    i18n.changeLanguage(selectedLng);
  };

  return (
    <div>
      <Modal
        closable={false}
        maskClosable={false}
        open={isOpen}
        footer={null}
        width={480}
        mask={true}
      >
        <div style={{ margin: "0 auto" }} align="center" className="mt-2">
          <h6
            className="auth-header-label"
            style={{ textTransform: "initial" }}
          >
            {t("pages.login.session_time_desc", {
              defaultValue: "Your Online Banking session is about to timeout",
            })}
          </h6>
          <span class="base-timer__label mt-3" align="center">
            {seconds}
          </span>
          <div className="mt-4 mb-3 d-flex justify-content-between mx-5">
            <Button
              style={{ width: 120 }}
              size="large"
              className="secondary-btn hide-xs"
              onClick={onLogOffCall}
            >
              {t("buttons.logout_button", {
                defaultValue: "LogOut",
              })}
            </Button>
            <Button
              size="large"
              style={{ width: 100 }}
              className="secondary-btn hide-lg"
              onClick={onLogOffCall}
            >
              {t("buttons.yes_btn", {
                defaultValue: "yes",
              })}
            </Button>
            <Button
              type="primary"
              className="primary-btn hide-xs"
              size="large"
              onClick={onRequestClose}
            >
              {t("buttons.continue_bank", {
                defaultValue: "Continue Banking",
              })}
            </Button>
            <Button
              type="primary"
              className="primary-btn hide-lg mx-2"
              size="large"
              style={{ width: 100 }}
              onClick={onRequestClose}
            >
              {t("buttons.no_btn", {
                defaultValue: "No",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
